import get from "lodash.get";
import { useSelector } from "react-redux";
import { selectReaderManager } from "../../ReaderManagerEvents/ReaderManagerSlice";

/**
 * You can use this hook to get the indexes of the first, second, and last phrases of a given type.
 * You can also use this hook to determine if the current phrase is the first, second, or last phrase of a given type.
 * @param {*} currentPageIndex 
 * @returns {
 * firstPhraseIndexOfThisType,
 * secondPhraseIndexOfThisType,
 * lastPhraseIndexOfThisType,
 * isExamplePhraseOfThisType,
 * isSecondPhraseOfThisType,
 * isLastPhraseOfThisType}
 */
export default function usePhraseTypeIndexes(currentPageIndex, phraseType) {

    const readerManagerStates = useSelector(selectReaderManager)

    const { contextStates } = readerManagerStates;

    const currentPhraseIndex = currentPageIndex
    const phraseItems =  get(contextStates, 'currentStory.items', [])
    const phraseItemsTypes = phraseItems.map(item => item.type)
    const isContinuationStory = get(contextStates, 'currentStory.isContinuation', false);

    const firstPhraseIndexOfThisType = phraseItemsTypes.indexOf(phraseType)
    const secondPhraseIndexOfThisType = firstPhraseIndexOfThisType + 1
    const lastPhraseIndexOfThisType = phraseItemsTypes.lastIndexOf(phraseType)
    const isExamplePhraseOfThisType = currentPhraseIndex === firstPhraseIndexOfThisType && !isContinuationStory
    const isSecondPhraseOfThisType = currentPhraseIndex === secondPhraseIndexOfThisType && !isContinuationStory
    const isLastPhraseOfThisType = currentPhraseIndex === lastPhraseIndexOfThisType
    const isLastPageOfStory = currentPhraseIndex === phraseItems.length - 1

    const currentPhraseIndexOfThisType = currentPhraseIndex - firstPhraseIndexOfThisType

    return {
        phraseItems,
        phraseItemsTypes,
        firstPhraseIndexOfThisType,
        secondPhraseIndexOfThisType,
        lastPhraseIndexOfThisType,
        isExamplePhraseOfThisType,
        isSecondPhraseOfThisType,
        isLastPhraseOfThisType,
        currentPhraseIndexOfThisType,
        isLastPageOfStory
    }
}